require('../../bower_components/angular/angular');
require('../../bower_components/angular-resource/angular-resource');
require('../../bower_components/angular-cookies/angular-cookies');
require('../../bower_components/angular-order-object-by/src/ng-order-object-by');
require('../../bower_components/angular-route/angular-route');
require('../../bower_components/angular-scroll/angular-scroll');
require('../../bower_components/angular-busy/dist/index');
